// src/App.jsx
import React from 'react';
import AIVideoChat from './components/AIVideoChat';
import './index.css';

export default function App() {
  return (
    <div className="min-h-screen bg-[#1d1d1f] text-zinc-100 antialiased">
      <AIVideoChat />
    </div>
  );
}
